import classes from "./ThankYouPage.module.scss";
import { useState } from "react";
import { Youtube } from "@/components/ui/Icon/Youtube";
import { YoutubeModal } from "@/components/ui/YoutubeModal";
import type { ThankYouPageVideoProps } from "./ThankYouPageProps";
import { clsx } from "clsx";
import { getYouTubeVideoId } from "@/utils/media-helpers";

export function ThankYouPageVideo(props: ThankYouPageVideoProps) {
  const { config } = props;

  const [isPlaying, setIsPlaying] = useState<boolean>(false);

  const thumbnail = config["thank-you-page-video-thumbnail"]?.src;
  const videoId = getYouTubeVideoId(config["thank-you-page-video-url"]);

  return (
    <>
      {thumbnail && (
        <img
          src={thumbnail}
          alt=""
          className={classes.thumbnail}
          data-testid="video-thumbnail"
        />
      )}

      {!thumbnail && (
        <div className={clsx(classes.thumbnail, classes.thumbnailSolid)} />
      )}

      {videoId && (
        <>
          <button
            type="button"
            className={classes.playButton}
            onClick={() => setIsPlaying(true)}
            data-testid="video-play-button"
          >
            <Youtube size={48} className={classes.youtubeIcon} />
          </button>

          <YoutubeModal
            isOpen={isPlaying}
            onClose={() => setIsPlaying(false)}
            videoId={videoId}
          />
        </>
      )}
    </>
  );
}
